<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  /*background: url("assets/images/indexbgc.jpg") no-repeat;*/
  /*background-size: 100% 100%;*/
}
</style>
